import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import styles from "./InterventionWidget.module.scss";
import { InterventionWidgetOutput, InterventionWidgetOutputConfiguration } from "./InterventionWidgetOutput";
import { PortableText } from "@portabletext/react";
import { customComponentRenderers } from "../Paragraph/Citation";
export interface InterventionWidgetProps {
  default_sum: number;
  title: string;
  description: any[];
  donationLabel?: string;
  outputConfiguration?: InterventionWidgetOutputConfiguration;
  /* From site settings */
  currency: string;
  locale: string;
}
export const InterventionWidget: React.FC<InterventionWidgetProps> = t0 => {
  const $ = _c(24);
  const {
    default_sum,
    title,
    description,
    donationLabel,
    outputConfiguration,
    currency,
    locale
  } = t0;
  const [sum, setSum] = useState(default_sum);
  if (!outputConfiguration) {
    return null;
  }
  let t1;
  if ($[0] !== title) {
    t1 = <h3>{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description && <PortableText value={description} components={customComponentRenderers} />;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={styles.header}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = donationLabel ?? "Donasjon";
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => {
      if (e.target.value.length <= 9) {
        setSum(parseInt(e.target.value) || 0);
      }
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== sum) {
    t6 = <div className={styles.inputWrapper}><input data-cy="impact-input" type="tel" value={sum} onChange={t5} name="sum" /></div>;
    $[8] = sum;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className={styles.input}><div className={styles.input}><label>{t4}:{t6}</label></div></div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== currency || $[14] !== locale || $[15] !== outputConfiguration || $[16] !== sum) {
    t8 = <div className={styles.output}><InterventionWidgetOutput sum={sum} configuration={outputConfiguration} currency={currency} locale={locale} /></div>;
    $[13] = currency;
    $[14] = locale;
    $[15] = outputConfiguration;
    $[16] = sum;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className={styles.grid}>{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t9) {
    t10 = <div className={styles.wrapper}>{t3}{t9}</div>;
    $[21] = t3;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};